import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
/**
 * Modular page layout component. Use this as a base for all pages.
 */
export const PageLayout = ({ children, header, footer }) => {
    return (_jsxs(Root, { children: [header, _jsx(Content, { children: children }), footer] }));
};
const Root = styled.div `
    height: 100%;
    width: 100%;
    overflow: auto;
    color: #ffffff;
`;
const Content = styled.div `
    min-width: 0;
    min-height: 100vh;
    box-sizing: border-box;
    padding-top: calc(var(--TopWedge_Height, 0) + 1rem);
    padding-bottom: calc(var(--BottomWedge_Height, 0) + 1rem);
    display: flex;
    align-items: center;
    justify-content: center;
`;
